// Registro central e inmutable. registrarMovimiento se usa desde el CRUD de
// otros dominios; las operaciones de stock atómicas registran su movimiento
// dentro de la función SQL, no aquí.
import { insforge } from '../insforge';
import { getUsuarioActual } from '../session';
import type { Movimiento } from '../../types';

export interface NuevoMovimiento {
  tipo: string;
  descripcion?: string;
  bodega_origen?: string | null;
  bodega_destino?: string | null;
  item_tipo?: string | null;
  item_id?: string | null;
  item_nombre?: string | null;
  cantidad?: number | null;
  detalle?: unknown;
}

export async function registrarMovimiento(m: NuevoMovimiento): Promise<void> {
  const { error } = await insforge.database.from('movimientos').insert([
    {
      usuario: getUsuarioActual(),
      tipo: m.tipo,
      descripcion: m.descripcion ?? '',
      bodega_origen: m.bodega_origen ?? null,
      bodega_destino: m.bodega_destino ?? null,
      item_tipo: m.item_tipo ?? null,
      item_id: m.item_id ?? null,
      item_nombre: m.item_nombre ?? null,
      cantidad: m.cantidad ?? null,
      detalle: m.detalle ?? null,
    },
  ]);
  if (error) throw new Error(error.message);
}

export interface FiltrosMovimientos {
  bodegaId?: string;
  tipo?: string;
  limit?: number;
}

export async function listarMovimientos(filtros: FiltrosMovimientos = {}): Promise<Movimiento[]> {
  let q = insforge.database.from('movimientos').select('*').order('created_at', { ascending: false });
  if (filtros.tipo) q = q.eq('tipo', filtros.tipo);
  if (filtros.limit) q = q.limit(filtros.limit);
  const { data, error } = await q;
  if (error) throw new Error(error.message);
  let rows = (data ?? []) as Movimiento[];
  // El filtro por bodega abarca origen O destino: se aplica en cliente.
  if (filtros.bodegaId) {
    rows = rows.filter(
      (r) => r.bodega_origen === filtros.bodegaId || r.bodega_destino === filtros.bodegaId,
    );
  }
  return rows;
}
